export const LOST_SALES_SAFE_PERIOD_OPTIONS = [7, 14, 21, 30];
